import { BaseTLComponent, AxiosResponse, EnumsService, EnumsFilter, tlLogError, Watch } from "./CoreBase";

interface iTableParam {
	perPage: number;
	currentPage: number;
	sortBy: string;
	sortDesc: boolean;
	filters: string;
}

export default abstract class BaseTLTableComponent extends BaseTLComponent {

	protected langInit = '';

	protected tableData: any[] = [];
	protected fields: any[] = [];
	protected gridFields: any[] = [];
	protected filters: any[] = [];
	protected buttons: any[] = [];
	protected detailName: string = '';
	protected modalContent: string = 'Dotaz?';
	protected itemsSelected: any; //pomocna pro smazani
	protected selectItems: any[] = []; //vyber vice prvku
	protected isDelete: boolean = false; //pomocna 
	protected deleteItemsList: number[] = []; //vybrane prvky na smazání
	protected isWarningBeforeDelete: boolean = false; //varovani pred smazaním (kdyz napriklad existuji nejake vazby)
	protected allowEdit: boolean = false; // kdyz chceme povolit jit na detail napr. vlatnikovi (nema pravo canRead)
	//texty pro upozornení před smazaním 
	private messageRemoveOne = '';
	private messageRemoveTwoFour = '';
	private messageRemoveFiveAndMore = '';

	protected tableParams: iTableParam = { perPage: 50, currentPage: 1, sortBy: '', sortDesc: false, filters: '' };

	countToRemove = 0;

	private enumsServiceTable: EnumsService = new EnumsService();

	protected created( fetchOnStart: boolean = true) {
		this.setbuttons();
		this.setFields();
		this.setfilters(null);
		if (fetchOnStart) {
			this.fetchData();
		}
	}

	protected deleteList() {
		this.deleteListServer().then(response => {
			this.isBusy = false;
			this.fetchData();
			
			
		}).catch(error => {
			this.isBusy = false;
			this.showErrorMessageFromResponse(error);
		});			

	}




	protected showErrorMessageFromResponse(error: any): void {
		let errorMessage = this.$t('global.messageErrorUnexpected');
		if (error.status == undefined) {
			errorMessage = this.$t('global.messageErrorTimeout');
		}
		else if (error.data.errors == undefined) {
			errorMessage = error.data;
		}
		if (error && error.data && error.data.errors && error.data.errors.length > 0) {
			errorMessage = '';
			for (var i = 0; i < error.data.errors.length; i++) {
				errorMessage += i > 0 ? ' <br> ' : '';
				errorMessage += error.data.errors[i];
			}
		}
		super.showAlertModalWithErrorMessageList(errorMessage);
	}

	protected timerRefresh() {
		this.fetchRefreshData();
    }

	//jednodussi refresh verze
	protected fetchRefreshData() {
		super.setOwner();
		
		if (super.hasRightOrIsOwnerPage()) {
			this.fetchRefreshDataFromServer().then((response) => {
				this.tableData = this.refreshItems(this.tableData, response.data);
				
			}).catch((error) => {
				tlLogError('BaseTLTableComponent', error);
			});
		}
		else {
			tlLogError('BaseTLTableComponent', this.$t('global.errorRight').toString());
		}
    }

	protected fetchData() {
		super.setOwner();
		if (super.hasRightOrIsOwnerPage()) {
			this.isBusy = true;
			this.fetchDataFromServer().then((response) => {
				this.prepareItems(response.data);
				this.tableData = response.data;
				this.isBusy = false;
			}).catch((error) => {
				if (error.status == undefined) {
					error = this.$t('global.messageErrorTimeout');
				}
				this.isBusy = false;
				if (!super.isTokenExpired(error)) {
					this.showErrorMessage(error);
				}
			});
		}
		else {
			//řeseni které vypada že funguje
			this.$nextTick(() => {
				this.showAlertModalWithTitleAndContent(this.$t('global.error').toString(), this.$t('global.errorRight').toString());
			});
			//TODO showError message nemáte prava
			// VaPTODO - bohuzel error message se zobrazi az po te, co je komponenta mounted, do te doby se neozbrazi, coz je vlastne spravne
			//         - stejne tak, pokud se vyskytne nekolik showmessage, tak se uzivateli zobrazi pouze ta posledni, jelikoz se neceka na odznaceni te prvni zpravy
			//         - z toho duvodu musime namyslet a udelat variantu, ze se chybove zpravy budou ukladat do nejake kolekce chyb a jakmile dojde na mounted komponenty, tak se dane zpravy postupne zobrazi
		}
	}


	protected setDetailName(detailName: string) {
		this.detailName = detailName;
	}

	protected deleteListServer(): Promise<AxiosResponse<any>> {
		return super.NoCall();
	}

	//TODO jeste jinak
	protected loadFilters(value: any) {
		if (value != null) {
			this.setfilters(value);
		}
	}

	//TODO tady smazat
	protected createNewClick(elementId: any) {
		//this.$router.push({ name: this.detailName, query: this.getParamsQuery(elementId, "new") });
		//parametry tam musi zustat kvuli Michaelu ...platby
		this.$router.push({ name: this.detailName, params: this.getParams(elementId, "new"), query: this.getParamsQuery(elementId, "new")  });
	};

	protected detailClick(elementId: any) {
		if (this.canRead || this.allowEdit) {
			this.$router.push({ name: this.detailName, params: this.getParams(elementId, "detail"), query: this.getParamsQuery(elementId, "detail") });
		}
	};

	//protected updateClick(elementId: any) {
	//	this.$router.push({ name: this.detailName, params: this.getParams(elementId, "details") });
	//};

	protected deleteClick(elementId: any) {
		this.$router.push({ name: this.detailName, params: this.getParams(elementId, "delete"), query: this.getParamsQuery(elementId, "delete") });
	};


	protected getParamsQuery(elementId: any, type: string): {} {
		//puvodni
		//let params = Object.assign({ id: elementId, type: type },
		//	(this.getOptionalParams())
		//);
		
	//	elementId = elementId == undefined ? "0" : elementId;
		let params = Object.assign({ id: elementId },
			(this.getOptionalParams())
		);

		return params;
	}

	//tohle se bude posilat do param
	protected getParams(elementId: any, type: string): {} {
		let params = Object.assign({ id: elementId, type: type },
			this.getOptionalParams(),
			this.getOptionalOnlyParams()
		);
		return params;
	}

	protected getOptionalParams(): {} {
		return {};
	}

	//tohle je pouze v parametrech a neni to v query
	protected getOptionalOnlyParams(): {} {
		return {};
	}

	////TODO zatim posilam vsechny parametry ale casme by melo byt jen getOptionalOnlyParams
	//private getParamsAll(): {} {
	//	var result = {};
	//	result = this.getOptionalOnlyParams();
	//	result.
	//	return result;
 //   }

	protected setbuttons(): void {

	};

	
	//nacteni skupinových filtru
	protected async loadFiltersEnum(pattern: any) {
		var identifEnum = pattern.key;
		let enumsFilter: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, identifEnum, false);
		var result: any[] = [];
		await this.enumsServiceTable.getAllByFilter(enumsFilter).then((response) => {
			for (var i = 0; i < response.data.length; i++) {	
				result.push({
					key: pattern.key + i, value: response.data[i].identifier, label: response.data[i].name, selected: pattern.selected,
					type: pattern.type, group: pattern.group, groupId: pattern.groupId, groupName: pattern.groupName, headName: pattern.headName, isNegative: pattern.isNegative
				});
			}
		});

		for (var i = 0; i < result.length; i++) {
			if (this.filters.filter(c => c.key == result[i].key).length == 0)
				this.filters.push(result[i]);
		}
	}

	

	protected async loadFiltersEnumList(pattern: any[]) {
		for (var ma = 0; ma < pattern.length; ma++) {        
		var identifEnum = pattern[ma].key;
		let enumsFilter: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, identifEnum, false);
		var result: any[] = [];
			await this.enumsServiceTable.getAllByFilter(enumsFilter).then((response) => {
			
				let onlyEnum = false;
				let  onlyEnumFilter : string[]=[];
				if ((pattern[ma] as any).onlyEnum != undefined) {
					onlyEnum = true;
					let enumsString = (pattern[ma] as any).onlyEnum.toString();
					onlyEnumFilter = enumsString.split(',');
				}

				
				for (let i = 0; i < response.data.length; i++) {
					if (!onlyEnum || (onlyEnum && onlyEnumFilter.some(c => c === response.data[i].identifier))) {
						result.push({
							key: pattern[ma].key + i,
							value: response.data[i].identifier,
							label: response.data[i].name,
							selected: pattern[ma].selected,
							type: pattern[ma].type,
							group: pattern[ma].group,
							groupId: pattern[ma].groupId,
							groupName: pattern[ma].groupName,
							headName: pattern[ma].headName,
							isNegative: pattern[ma].isNegative
						});
					}
				}

		});

		for (var i = 0; i < result.length; i++) {
			if (this.filters.filter(c => c.key == result[i].key).length == 0)
				this.filters.push(result[i]);
			}
		}
	}


	protected setDeleteMessage(onePerson: string,twoFour: string, fiveAndMore: string) {
		this.messageRemoveOne = onePerson;
		this.messageRemoveTwoFour = twoFour;
		this.messageRemoveFiveAndMore = fiveAndMore;
	}

	protected prepareRemoveMessage() {		
		var allMessage = this.messageRemoveOne;
		if (this.countToRemove > 1) {
			var message = '';
			message = this.countToRemove > 1 && this.countToRemove < 5 ? this.messageRemoveTwoFour : message;
			message = this.countToRemove >= 5 ? this.messageRemoveFiveAndMore : message;
			var count = " <span style=color:red; font-weight: 900;> &nbsp;" + this.countToRemove + " &nbsp;  </span>  ";
			allMessage = this.countToRemove < 5 ? this.messageRemoveTwoFour : this.messageRemoveFiveAndMore;
			allMessage = allMessage.replace('{0}', count);
		}		
		return allMessage;
	}

	protected selectRows(items: any) {
		this.selectItems = [];
		for (var i = 0; i < items.length; i++) {
			this.selectItems.push(items[i].id);
		}
	}

	protected callActionClick() {
    }

	public showAlertBeforeActionClickBase(itemsSelected: any, modalContent: string, isDelete: boolean = false) : void {
		this.modalContent = modalContent;
		this.isDelete = isDelete;
		this.itemsSelected = itemsSelected;
		if (this.$store.state.askBeforeDelete == false && this.isWarningBeforeDelete == false) {		
			this.callActionClick();
		}
		else {
			this.showAlertModalById('alertModalIdAllow');
		}
	}


	//protected showAllertToDeleteClick(itemsSelected: any) {
	//	//VaPTODO - proc uzivatele?
	//	this.showAlertBeforeActionClick(itemsSelected, 'Opravdu chcete smazat uživatele?');
	//}

	//připrava pro hromadne smazani
	protected getSelectedList(): number[] {
		// bud mame pole cisel - kliklo se na tlacitko smazat pod tabulkou
		let idList: number[] = this.itemsSelected as number[];
		// nebo mame pouze jedno cislo - kliklo se na ikonu kose na radku
		if (idList.length == undefined || idList.length <= 0) {
			let id: number = this.itemsSelected as number;
			if (id) {
				idList = [id];
			}
		}
		return idList;
	}
	//@ts-ignore
	@Watch('$i18n.locale')
	changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
		this.fetchData();
	}


	protected abstract setfilters(value: any): void;
	protected abstract setFields(): void;
	protected abstract prepareItems(items: any[]): void;
	protected abstract fetchDataFromServer(): Promise<AxiosResponse<any>>;
	protected abstract fetchRefreshDataFromServer(): Promise<AxiosResponse<any>>;
	protected abstract refreshItems(items: any[],refreshData: any[]): any[];
}